module.exports = __webpack_public_path__ + "img/img03m.11e3c06a.svg";